import { FormCostObject } from "../models/FormCostObject";
import { ModifiedShipmentObject } from "../models/ShipmentObject";
import { ShellShipmentFormObject } from "../models/ShellShipmentFormObject";
import { OrderCostObject } from "../models/OrderCostObject";

export const getDefaultShellShipment = (
  shipment?: ModifiedShipmentObject
): ShellShipmentFormObject => {
  const items = shipment?.items ?? [];
  return {
    id: shipment?.id ?? null,
    customerId: shipment?.customerId ?? 0,
    customerName: shipment?.customerName ?? "",
    shellQty: shipment != null ? "1" : "0",
    itemQty: items.length.toString() ?? "0",
    pickup: {
      id: shipment?.pickup?.id,
      name: shipment?.pickup?.name ?? "",
      formatted: shipment?.pickup?.formatted ?? "",
      shortFormatted: shipment?.pickup?.shortFormatted ?? "",
      city: shipment?.pickup?.city ?? "",
      state: shipment?.pickup?.state ?? "",
      zip: shipment?.pickup?.zip ?? "",
      address: shipment?.pickup?.address ?? "",
      lat: shipment?.pickup?.lat ?? 0,
      lon: shipment?.pickup?.lon ?? 0,
      poNumber: shipment?.pickup?.poNumbers
        ? shipment?.pickup?.poNumbers[0]
        : "",
      appointment: {
        scheduling: "9400",
        timezone: shipment?.pickup?.appointment?.timezone ?? "",
        startDate: shipment?.pickup?.appointment?.start
          ? new Date(shipment?.pickup?.appointment?.start)
          : null,
        endDate: shipment?.pickup?.appointment?.end
          ? new Date(shipment?.pickup?.appointment?.end)
          : null,
      },
      notes: shipment?.pickup?.notes ?? "",
    },
    delivery: {
      id: shipment?.delivery?.id,
      name: shipment?.delivery?.name ?? "",
      formatted: shipment?.delivery?.formatted ?? "",
      shortFormatted: shipment?.delivery?.shortFormatted ?? "",
      city: shipment?.delivery?.city ?? "",
      state: shipment?.delivery?.state ?? "",
      zip: shipment?.delivery?.zip ?? "",
      address: shipment?.delivery?.address ?? "",
      lat: shipment?.delivery?.lat ?? 0,
      lon: shipment?.delivery?.lon ?? 0,
      poNumber: shipment?.delivery?.poNumbers
        ? shipment?.delivery?.poNumbers[0]
        : "",
      appointment: {
        scheduling: "9400",
        timezone: shipment?.delivery?.appointment?.timezone ?? "",
        startDate: shipment?.delivery?.appointment?.start
          ? new Date(shipment?.delivery?.appointment?.start)
          : null,
        endDate: shipment?.delivery?.appointment?.end
          ? new Date(shipment?.delivery?.appointment?.end)
          : null,
      },
      notes: shipment?.delivery?.notes ?? "",
    },
    costs:
      items.length > 0
        ? mapExistingShellShipmentCosts(items[0].costs)
        : [getDefaultCost()],
  };
};

const mapExistingShellShipmentCosts = (
  costs: OrderCostObject[]
): FormCostObject[] =>
  costs.map(
    (cost): FormCostObject => ({
      id: crypto.randomUUID(),
      code: {
        key: cost?.code?.key ?? "",
        value: cost?.code?.value ?? "",
      },
      qty: cost?.qty?.toString() ?? "0",
      note: cost?.note?.toString() ?? "",
      price: cost?.price?.toString() ?? "0",
      amount: cost?.amount?.toString() ?? "0",
    })
  );

export const getDefaultCost = (): FormCostObject => ({
  id: crypto.randomUUID(),
  code: {
    key: "",
    value: "",
  },
  qty: "0",
  note: "",
  price: "0",
  amount: "0",
});
